var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuditRequestView',{attrs:{"preview":_vm.preview,"previewID":_vm.previewID == 0 ? parseInt(this.$route.params.id) : _vm.previewID,"submitterName":_vm.submitterName}})
}
var staticRenderFns = []

export { render, staticRenderFns }